const BLOCK_TYPES = {
  METRIC: 'Metric',
  SERVICE: 'Service',
  CONTRIBUTOR: 'Contributor'
}

module.exports = { BLOCK_TYPES }
